<template>
  <div class="content">
    <TopNavigation :top-act="'6'" v-if="!ZMLApp"/>
    <!--    pc端-->
    <div class="search-box" v-if="$store.state.webNavigator == 'pc'">
      <div class="search-box-right">
        <div class="search">
          <div class="search-items">
            <p class="search-font36">产品防伪查询</p>
            <p class="search-font22">请输入包装上16位防伪码，即可辨别真伪。</p>
            <input id="inspectID" class="inspect" type="text" placeholder="请输入您要查询的16位防伪码"/>
            <input type="button" value="查询" @click="querycode"/>
            <div class="search-font16">
              <p>1、防伪查询的方式共有三种：微信查询、电话查询、网站查询；</p>
              <p> 2、正规的防伪码由16位数字组成，查询时请刮去涂层，数一下你的防伪码是不是16位数字。</p>
            </div>
          </div>
          <div class="product-image">
            <img :src="src1" alt="防伪编码"
                 class="product-image-img" title="">
          </div>
        </div>
        <div class="search">
          <div class="search-items">
            <p class="search-font36">微信顾问查询</p>
            <p class="search-font22">请输入您要查询的微信号，即可辨别真伪。</p>
            <input id="wechatID" type="text" placeholder="请输入您要查询的微信号"/>
            <input type="button" value="查询" @click="querywechatcode"/>
            <div class="search-font16" style="text-align: left">
              <p>1、在查询框内输入微信号可以查询你的唯一专属顾问查询是否为真伪；</p>
              <p> 2、脂玫乐健康团队专属顾问均可查询，如果输入专属顾问微信号查询提示为“此微信号为脂玫乐健康团队专属顾问”则为真，提示为不是或其他提示均不是脂玫乐健康团队产品专属顾问号。</p>
              <p class="tip">
                <span>温馨提示：</span>
                此为脂玫乐健康团队专属顾问微信号真伪查询，官方唯一认证渠道，其余均为仿冒！
              </p>
            </div>
          </div>
          <div class="search-items">
            <p class="search-font36">电话顾问查询</p>
            <p class="search-font22">请输入您要查询的手机号或座机号。</p>
            <input id="phoneID" type="text" placeholder="请输入您要查询的手机号或座机号"/>
            <input type="button" value="查询" @click="queryphone"/>
            <div class="search-font16" style="text-align: left">
              <p>1、在查询框内输入座机号（请加区号）可以查询你的唯一专属顾问查询是否为真伪；</p>
              <p> 2、脂玫乐健康团队专属顾问均可查询，如果输入专属顾问座机号查询提示为“此手机号或座机号为脂玫乐 健康团队专属顾问”则为真，提示为不是或其他提示均不是脂玫乐健康团队产品专属顾问号。</p>
              <p class="tip">
                <span>温馨提示：</span>
                此为脂玫乐健康团队专属顾问手机号或座机号真伪查询，官方唯一认证渠道，其余均为仿冒！
              </p>
            </div>
          </div>
          <div class="modal" id="modal">
            <div class="modal-dialog">
              <div class="dialog-head">
                脂玫乐提示您：
                <i class="iconfont icon-pc-3 fr" id="close" @click="closes()"></i>
              </div>
              <div class="dialog-body">
                <p><i></i><span id="code"></span></p>
                <p class="message">您所查询的<span id="result"></span></p>
                <p id="tip" class="tip"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    手机端-->
    <div :class="classObject" v-else>
      <div :class="{'phone-Box':true,'app-phone-box':ZMLApp}">
        <div class="banner-box">
          <p class="banner-tlt">产品防伪查询</p>
          <p class="banner-p">请输入包装上16位防伪码，即可辨别真伪。</p>
          <div class="part-input-box flexCenter">
            <input v-model="searchText1" type="text" class="part-input" placeholder="请输入您要查询的16位防伪码"/>
          </div>
          <div class="banner-btn" @click="productReg">
            查 询
          </div>
          <p class="banner-text">
            1、防伪查询的方式共有三种：微信查询、电话查询、网站查询； <br><br>
            2、正规的防伪码由16位数字组成，查询时请刮去涂层， 数一下你的防伪码是不是16位数字。
          </p>
          <div class="banner-img"></div>
        </div>
        <div class="banner-box">
          <p class="banner-tlt">微信顾问查询</p>
          <p class="banner-p">请输入您要查询的微信号，即可辨别真伪。</p>
          <div class="part-input-box flexCenter">
            <input v-model="searchText2" type="text" class="part-input" placeholder="请输入您要查询的微信号"/>
          </div>
          <div class="banner-btn" @click="weixinReg">
            查 询
          </div>
          <p class="banner-text">

            1、在查询框内输入微信号可以查询你的唯一专属顾问查询是否为真伪； <br><br>
            2、脂玫乐健康团队专属顾问均可查询，如果输入专属顾问微信号查询提示为“此微信号为脂玫乐健康团队专属顾问”则为真，提示为不是或其他提示均不是脂玫乐健康团队产品专属顾问号。<br><br>
            <span style="color: #00CDA2">温馨提示：</span>此为脂玫乐健康团队专属顾问微信号真伪查询，官方唯一认证渠道，其余均为仿冒！
          </p>
        </div>
        <div class="banner-box">
          <p class="banner-tlt">电话顾问查询</p>
          <p class="banner-p">请输入您要查询的手机号或座机号，即可辨别真伪。</p>
          <div class="part-input-box flexCenter">
            <input v-model="searchText3" type="text" class="part-input"
                   placeholder="请输入您要查询的手机号或座机号"/>
          </div>
          <div class="banner-btn" @click="phoneReg">
            查 询
          </div>
          <p class="banner-text">
            1、在查询框内输入手机号或座机号（请加区号）可以查询你的唯一专属顾问查询是否为真伪；<br><br>
            2、脂玫乐健康团队专属顾问均可查询，如果输入专属顾问微信号查询提示为“此手机号或座机号为脂玫乐 健康团队专属顾问”则为真，提示为不是或其他提示均不是脂玫乐健康团队产品专属顾问号。<br><br>
            <span style="color: #00CDA2">温馨提示：</span>此为脂玫乐健康团队专属顾问手机号或座机号真伪查询，官方唯一认证渠道，其余均为仿冒！
          </p>
        </div>
        <div class="page-reg-big-box flexCenter" v-show="showStatus">
          <div class="page-reg-box">
            <div class="page-reg-top flexSpace">
              <div class="page-reg-title">脂玫乐提示您：</div>
              <div class="page-reg-close-box" @click="changeAlertStatus">
                <img class="page-reg-close-icon"
                     src="https://jusewebapp.zmelo.com/zml-gw/phone/huicha.png" title="" alt="">
              </div>
            </div>
            <!--产品查询-->
            <div class="reg-text-box1" v-if="searchType=='1'">
              <div class="reg-text1">经系统验证</div>
              <div class="reg-text1">您所查询的防伪编码({{searchText1}}) <span :class="findResult=='1'?'success':'error'">{{findResult=='1'?'存在':'不存在'}}</span>
              </div>
              <div class="reg-text1">{{findResult=='1'?'谢谢您的查询':'请您核实后再试谢谢您的查询'}}，</div>
            </div>
            <!--微信查询/电话查询-->
            <div class="reg-text-box2" v-else>
              <div class="reg-value-box flexCenter">
                <div class="reg-value-icon-box">
                  <img class="reg-value-icon"
                       :src="findResult=='1'?'https://jusewebapp.zmelo.com/zml-gw/etyjg1.png':findResult=='3'?'https://jusewebapp.zmelo.com/zml-gw/etyjg2.png':'https://jusewebapp.zmelo.com/zml-gw/etyjg3.png'"
                       alt="" title="">
                </div>
                <div class="reg-value" :class="findResult=='1'?'success':'error'">
                  {{searchType=='2'?searchText2:searchText3}}
                </div>
              </div>
              <div class="reg-value-remind">
                您所查询的
                <span class="reg-value-remind-result" :class="findResult=='1'?'success':'error'" v-if="searchType=='2'">{{searchType+findResult=='1'?'微信号为官方客服微信号码':findResult=='3'?'微信号为非官方微信号':findResult=='2'?'微信号为本公司其他品牌客服微信号':'查询失败'}}</span>
                <span class="reg-value-remind-result" :class="findResult=='1'?'success':'error'" v-if="searchType=='3'">{{searchType+findResult=='1'?'电话号码为官方客服电话号码':findResult=='3'?'电话号码为非官方客服电话号码':findResult=='2'?'电话号码为本公司其他品牌客服电话号码':'查询失败'}}</span>
              </div>
            </div>
            <div class="reg-result-text" :class="findResult=='1'?'success':'error'">
              {{findResult!='3'?'谢谢您的查询!':findResult=='4'?'':'谨防上当受骗！'}}
            </div>
          </div>
        </div>
      </div>

    </div>
    <FooterNavigation v-if="!ZMLApp"/>
  </div>
</template>
<script>
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import {myFun, } from '../../plug/modifyImagePath';
import config from '@/others/interface';
import {mapState, } from 'vuex';
import common from '../../store/common/common';

export default {
  name: 'search',
  components: {TopNavigation, FooterNavigation, },
  title () {
    return {
      title: '脂玫乐防伪查询|减肥产品真假查询|脂玫乐真假查询-脂玫乐',
      keywords: '脂玫乐防伪查询，减肥产品真假查询，脂玫乐真假查询',
      description: '脂玫乐防伪查询，提供脂玫乐产品防伪查询和电话顾问查询。',
    };
  },
  computed: {
    ...mapState(['ZMLApp', ]),
    classObject: function () {
      return {
        'phone-page': true,
        'zmlApp-page': this.ZMLApp,
      };
    },
  },
  data () {
    return {

      src1: 'https://jusewebapp.zmelo.com/zml-gw/fangwei.png',
      searchType: 1, // 查询类型  1：产品 2：微信 3：电话
      showStatus: false,
      searchText1: '',
      searchText2: '',
      searchText3: '',
      findResult: '', // 1:正品 2:本公司产品但不是此品牌 3:假冒 4:查询不到数据
    };
  },
  methods: {
    goBackTop () {
      $('body').scrollTop(0);
    },
    changeAlertStatus () {
      this.showStatus = !this.showStatus;
    }, // 更改结果弹框显示状态
    async productReg () {
      if (!this.searchText1 || this.searchText1.length != '16') {
        this.$message.error('请输入正确的防伪码');
        return;
      }
      // https://hlw.gooeto.com
      this.searchType = '1';
      let url = config.hlwAPI + '/gwAPI/gfyy/product/getCode?key=' + this.searchText1;
      let that = this;
      $.getJSON(url, function (backdata) {
        if (backdata.data && backdata.data.indexOf('不存在') != '-1') {
          that.findResult = '3';
        } else {
          that.findResult = '1';
        }
        that.changeAlertStatus();
      });
    }, // 产品验证（移动端）
    async weixinReg () {
      if (!this.searchText2) {
        return;
      }
      this.searchType = '2';
      let account = this.searchText2.trim();
      let types = 2;
      let payurl2 = 'https://apicrm.gooeto.com:808/api/';
      let payurltest2 = 'https://apicrmceshi.gooeto.com/api/';
      if (!account) return;
      let url = payurl2 + 'ReportForm/WxIsLegal?code=' + account + '&type=' + types;
      let that = this;
      $.get(url, function (res) {
        if (res.Code == 0) {
          if (res.Data != null && res.Data.ID > 0) {
            that.findResult = '1';
          } else {
            that.findResult = '3';
          }
        } else {
          that.findResult = '4';
        }
        that.changeAlertStatus();
      });
    }, // 微信验证（移动端）
    async phoneReg () {
      console.log(8989, this.searchText3);
      if (!this.searchText3 || !(/\d{11}/g.test(this.searchText3))) {
        this.$message.error('请输入正确信息');
        return;
      }
      this.searchType = '3';
      let cellphone = this.searchText3.trim();
      let codephone = {
        'cellphone': cellphone,
        'type': 2,
      };
      let payurl = 'https://crm.gooeto.com:808/api/';
      let payurltest = 'https://apicrmceshi.gooeto.com/api/';
      let that = this;
      $.ajax({
        url: payurl + 'phone/CheckPhone',
        type: 'post',
        contentType: 'application/x-www-form-urlencoded',
        data: codephone,
        success: function (d) {
          let result = d;
          if (result.Code == 0) {
            if (result.Data.resultCode == 'true' && result.Data.resultMsg == 'right') {
              that.findResult = '1';
            } else if (result.Data.resultCode == 'true' && (result.Data.resultMsg == 'wrong' || result.Data.resultMsg == 'null')) {
              that.findResult = '2';
            } else {
              that.findResult = '3';
            }
          } else {
            that.findResult = '4';
          }
          that.changeAlertStatus();
        },
      });
    }, // 手机验证（移动端）
    async querycode () {
      let code = $('#inspectID').val();
      let url = config.hlwAPI + '/gwAPI/gfyy/product/getCode?key=' + code;
      if (code.length > 0) {
        $.getJSON(url, function (backdata) {
          $('#code').prev().css({
            'height': '0',
          });
          if (backdata.data && backdata.data.indexOf('不存在') != '-1') {
            $('#result').text('经系统验证，\n' +
                '您所查询的防伪编码(' + code + ')不存在，\n' +
                '请您核实后再试，谢谢您的查询\n');
            $('#tip').text('谨防上当受骗！').css({'color': '#FF1919', 'font-size': '50px', });
          } else {
            $('#result').text('经系统验证，\n' +
                '您所查询的防伪编码(' + code + ')真实存在');
            $('#tip').text('谢谢您对我们的信任！').css({'color': '#00DAAC', 'font-size': '50px', });
          }
          $('#modal').show();
        });
      }
    },
    async querywechatcode () {
      let account = $('#wechatID').val().trim();
      let types = 2;
      let payurl2 = 'https://apicrm.gooeto.com:808/api/';
      let payurltest2 = 'https://apicrmceshi.gooeto.com/api/';
      if (!account) return;
      let url = payurl2 + 'ReportForm/WxIsLegal?code=' + account + '&type=' + types;
      $('#code').text(account);
      $.get(url, function (res) {
        if (res.Code == 0) {
          if (res.Data != null && res.Data.ID > 0) {
            $('#code').css({'color': '#00DAAC', 'font-size': '50px', })
              .prev().css({
                'background-image': 'url("https://jusewebapp.zmelo.com/zml-gw/etyjg1.png")',
                'background-size': '100% 100%',
                'vertical-align': 'text-bottom',
              });
            $('#result').text('微信号为官方微信号').css('color', '#00DAAC');
            $('#tip').text('谢谢您对我们的信任！').css({'color': '#00DAAC', 'font-size': '50px', });
          } else {
            $('#code').css({'color': '#FF1919', 'font-size': '50px', })
              .prev().css({
                'background-image': 'url("https://jusewebapp.zmelo.com/zml-gw/etyjg2.png")',
                'background-size': '100% 100%',
                'vertical-align': 'text-bottom',
              });
            $('#result').text('微信号为非官方微信号').css({'color': '#FF1919', 'font-size': '22px', });
            $('#tip').text('谨防上当受骗！').css({'color': '#FF1919', 'font-size': '50px', });
          }
        } else {
          $('#code').css({'color': '#FF1919', 'font-size': '50px', })
            .prev().css('background-image', 'url(/images/etyjg2.png)');
          $('#result').text('查询微信号失败').css({'color': '#FF1919', 'font-size': '50px', });
        }
        $('#modal').show();
      });
    },
    async queryphone () {
      var cellphone = $('#phoneID').val().trim();
      var codephone = {
        'cellphone': cellphone,
        'type': 2,
      };
      let payurl = 'https://crm.gooeto.com:808/api/';
      let payurltest = 'https://apicrmceshi.gooeto.com/api/';
      if (!cellphone) return;
      if (!codephone) return;
      $('#code').text(cellphone);
      $.ajax({
        url: payurl + 'phone/CheckPhone',
        type: 'post',
        contentType: 'application/x-www-form-urlencoded',
        data: codephone,
        success: function (d) {
          var result = d;
          if (result.Code == 0) {
            if (result.Data.resultCode == 'true' && result.Data.resultMsg == 'right') {
              $('#code').css({'color': '#00DAAC', 'font-size': '50px', })
                .prev().css({
                  'background-image': 'url("https://jusewebapp.zmelo.com/zml-gw/etyjg1.png")',
                  'background-size': 'cover',
                  'vertical-align': 'top',
                });
              $('#result').text('电话号码为官方客服电话号码').css('color', '#00DAAC');
              $('#tip').text('谢谢您对我们的信任！').css({'color': '#00DAAC', 'font-size': '50px', 'text-align': 'center', });
            } else if (result.Data.resultCode == 'true' && (result.Data.resultMsg == 'wrong' || result.Data.resultMsg == 'null')) {
              $('#code').css({'color': '#FF1919', 'font-size': '50px', })
                .prev().css({
                  'background-image': 'url("https://jusewebapp.zmelo.com/zml-gw/etyjg3.png")',
                  'background-size': 'cover',
                  'vertical-align': 'top',
                });
              $('#result').text('电话号码为本公司其他品牌客服电话号码').css({'color': '#FF1919', 'font-size': '22px', });
              $('#tip').text('谢谢您对我们的信任！').css({'color': '#FF1919', 'font-size': '50px', 'text-align': 'center', });
            } else {
              $('#code').css({'color': '#FF1919', 'font-size': '50px', })
                .prev().css({
                  'background-image': 'url("https://jusewebapp.zmelo.com/zml-gw/etyjg2.png")',
                  'background-size': 'cover',
                  'vertical-align': 'top',
                });
              $('#result').text('电话号码为非官方客服电话号码').css('color', '#FF1919');
              $('#tip').text('谨防上当受骗！').css({'color': '#FF1919', 'font-size': '50px', 'text-align': 'center', });
            }
          } else {
            $('#code').css({'color': '#FF1919', 'font-size': '50px', })
              .prev().css({
                'background-image': 'url("https://jusewebapp.zmelo.com/zml-gw/etyjg2.png")',
                'background-size': 'cover',
                'vertical-align': 'top',
              });
            $('#result').text('查询失败').css({'color': '#FF1919', 'font-size': '50px', 'text-align': 'center', });
            // $('#tip').text('谨防上当受骗！').css('color', '#FF1919');
          }

          $('#modal').show();
        },
      });
    },
    async closes () {
      $('#modal').hide();
    },
  },
  mounted () {
    console.log(909090, this.ZMLApp);
    if (this.ZMLApp) {
      document.getElementById('cnzz_stat_icon_1279115503').style.display = 'none';
    }
  },
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url("searchPhone.less");
  }

  @media screen and (min-width: 800px) {
    @import url("search.less");
  }

</style>



// WEBPACK FOOTER //
// search.vue